import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Arquivos de tradução
import ptBR from './locales/pt-BR.json';
import enUS from './locales/en-US.json';
import esES from './locales/es-ES.json';

const resources = {
  'pt-BR': {
    translation: ptBR
  },
  'en-US': {
    translation: enUS
  },
  'es-ES': {
    translation: esES
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    debug: process.env.NODE_ENV === 'development',
    
    // Aguardar carregamento dos recursos
    react: {
      useSuspense: true
    },

    interpolation: {
      escapeValue: false // React já escapa por padrão
    },

    detection: {
      // Ordem de detecção de idioma
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache no localStorage
      caches: ['localStorage'],
      // Chave para salvar no localStorage
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n;